import styled from '@emotion/styled';
import { CARD_BORDER_RADIUS, CARD_PADDING, CARD_PADDING_COMPACT, } from '../ProductCardCarousel.styles';
export const ProductImageFallbackContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: auto;
  flex: 0 0 auto;
  aspect-ratio: 1 / 1;
  border-radius: max(
    4px,
    calc(
      var(--border-radius, ${CARD_BORDER_RADIUS}px) -
        ${({ compactSize }) => compactSize ? CARD_PADDING_COMPACT : CARD_PADDING}px
    )
  );
  overflow: hidden;

  background: linear-gradient(
    135deg,
    var(--product-card-background, #2b2b2b) 0.02%,
    color-mix(
      in srgb,
      var(--product-card-background, #5f6368 75%),
      var(--product-card-font-color, #5f6368 25%)
    )
  );
  color: var(--product-card-font-color, '#404040');
`;
export const ProductImageParagraph = styled.p `
  object-fit: cover;
  display: block;
  font-size: 9px;
  text-align: center;
  margin: 0;
`;
